import { render, staticRenderFns } from "./main-notice.vue?vue&type=template&id=6329ba5d&scoped=true&"
import script from "./main-notice.vue?vue&type=script&lang=js&"
export * from "./main-notice.vue?vue&type=script&lang=js&"
import style0 from "./main-notice.vue?vue&type=style&index=0&id=6329ba5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6329ba5d",
  null
  
)

export default component.exports